<template>
  <div class="main_view">
    <!--导航栏-->
    <div class="report_head">
      <div class="report_head_item">
        <div class="report_head_left">
          <div class="report_info">
            <a href="/#/" target="_blank">
              <img src="/static/images/bigdata/maoyan_logo.png"/>
            </a>
          </div>
          <div class="line"></div>
          <div class="note">
            <span>小红书AI智能投放分析：<span style="color: #396AF2; font-weight: bolder">【{{keyWord}}】</span></span>
          </div>
        </div>
        <div class="report_head_right">
          <div class="item_right"  @mouseover="logoutOver" @mouseout="logoutOut">
            <img class="img_head" src="/static/images/bigdata/brand_head_icon.png"/>
            <div class="nick_name">{{nickName}}</div>
            <div class="logout" v-show="showLogin" @click="clickLogout">退 出 登 录</div>
          </div>
        </div>
      </div>
    </div>

    <!--切换栏-->
    <div class="report_home">
      <div class="shop">
        <div class="report_list">
          <div class="report_item_head">
            <div class="report_item_value" v-for="(headItem, headItemIndex) in headItems"
                 :key="headItemIndex" :class="{'selected' : headIndex === headItemIndex }" @click="clickHeadItem(headItemIndex)">{{headItem}}</div>
          </div>
        </div>
      </div>
    </div>
    <!--数据概览-->
    <div class="report_item">
      <div class="head_item">
        <span>达人数据概览</span>
      </div>
      <div class="report show_item">
        <div class="show_child_item" v-for="(result, resultIndex) in guideLists">
          <span class="name">{{result.value}}</span>
          <span class="note">{{result.title}}</span>
        </div>
      </div>
    </div>
    <!--echarts折线图 达人数量-->
    <div class="report_echarts">
      <div class="echarts_head">
        <span>达人数量趋势图</span>
      </div>
      <div class="echarts_map" ref="line_chart_kol">
      </div>
    </div>
    <!--echarts折线图 粉丝覆盖-->
    <div class="report_echarts">
      <div class="echarts_head">
        <span>达人粉丝覆盖数趋势图</span>
      </div>
      <div class="echarts_map" ref="line_chart_kolfans">
      </div>
    </div>

    <div class="report_echarts_double">
      <!--echarts柱状图 粉丝分布-->
      <div class="report_echarts_one">
        <div class="echarts_head">
          <span>达人粉丝分布图</span>
        </div>
        <div class="echarts_map" ref="bar_chart_fans">
        </div>
      </div>
      <!--echarts柱状图 薯种分布-->
      <div class="report_echarts_two">
        <div class="echarts_head">
          <span>达人薯种分布图</span>
        </div>
        <div class="echarts_map" ref="bar_chart_level">
        </div>
      </div>
    </div>

    <!--echarts柱状图 类目分布-->
    <div class="report_echarts">
      <div class="echarts_head">
        <span>达人类目分布图</span>
      </div>
      <div class="echarts_map" ref="bar_chart_category">
      </div>
    </div>

    <!--echarts饼状图 合作类型 笔记类型-->
    <div class="report_trend">
      <div class="report_echarts_one">
        <div class="echarts_head">
          <span>商业合作</span>
        </div>
        <div class="echarts_map" ref="pie_chart_cooperation">
        </div>
      </div>
      <div class="report_echarts_two">
        <div class="echarts_head">
          <span>达人性别</span>
        </div>
        <div class="echarts_map" ref="pie_chart_gender"></div>
      </div>
    </div>

    <!--echarts柱状图 地域分布-->
    <div class="report_echarts_map" style="padding-bottom: 20px;">
      <div class="echarts_head">
        <span>达人地域分布图</span>
      </div>
      <div class="echarts_map_map" ref="map_chart_location">
      </div>
    </div>
    <!--底部导航-->
<!--    <div  class="bottom_div">COPYRIGHT  2020-2024 杭州袤周云计算有限公司<a rel="nofollow" href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2022031665号</a></div>-->
  </div>
</template>

<script>
import * as echarts from 'echarts';
import china from "../comm/map/chinaChange.json";  //中国地图
import 'echarts-wordcloud';
import process from "shelljs";
export default {
  name: "BigdataHome",
  data() {
    return {
      showLogin: false,
      nickName: this.$cookies.get('UserName') || '演示账号',
      keyWord: this.$cookies.get('KeyWord'),
      headIndex: 0,
      headItems: ['达人分析', '笔记分析', '达人列表', '笔记列表', '爆文分析', '报备分析'],
      guideLists: [],
    }
  },
  methods: {
    clickHeadItem (headIndex) {
      // 跳转
      if (headIndex === 1) {
        this.$router.push('/note')
      }
      if (headIndex === 2) {
        this.$router.push('/kollist')
      }
      if (headIndex === 3) {
        this.$router.push('/notelist')
      }
      if (headIndex === 4) {
        this.$router.push('/notehot')
      }
      if (headIndex === 5) {
        this.$router.push('/notebaobei')
      }
    },
    clickLogout () {
      // 本地保存token
      this.$cookies.remove("UserToken");
      this.$cookies.remove("UserName");
      // 跳转
      this.$router.push('/login');
    },
    logoutOver () {
      this.showLogin = true;
    },
    logoutOut () {
      this.showLogin = false;
    },
    getListData() {
      let base = '/api';
      if (process.env.NODE_ENV === "development") {
        base = 'http://api.wushangxianzhi.com';
      }
      let url = '/api/v2/maocep/maocep_vue_xhs_echarts_kols';
      //数据请求 HTTP_AUTHORIZATION
      this.$axios.defaults.headers.common['Authorization'] = this.$cookies.get('UserToken')
      this.$axios({
        method: 'post',
        url: `${base}${url}`,
        responseType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
          'keyword': this.$cookies.get('KeyWord')
        })
      }).then((res) => {
        console.log("res ", res);
        // ===数据概览===
        let guidedata = res.data.result[0].guide_data;
        let guide_dic = { title: '达人总数', value: guidedata.kol_counts};
        let guide_dic1 = { title: '粉丝覆盖数', value: guidedata.kol_fans_counts};
        let guide_dic2 = { title: '笔记总数', value: guidedata.note_counts};
        let guide_dic3 = { title: '商业笔记数', value: guidedata.cooperate_counts};
        this.guideLists = [guide_dic, guide_dic1, guide_dic2, guide_dic3];
        // ===折线图===
        let linedata = res.data.result[0].line_data;
        // 达人数-趋势图
        let lineoption_kol = {
          tooltip: {
            show: true,
            trigger: 'axis'
          },
          xAxis: {
            type: 'category',
            data: linedata.dates,
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: linedata.pub_kols,
              type: 'line',
              smooth: true,
              color: '#396AF2'
            }
          ]
        }
        let linechart_kol = echarts.init(this.$refs.line_chart_kol);
        linechart_kol.setOption(lineoption_kol);
        // 达人粉丝覆盖数-趋势图
        let lineoption_kolfans = {
          tooltip: {
            show: true,
            trigger: 'axis'
          },
          xAxis: {
            type: 'category',
            data: linedata.dates,
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: linedata.pub_kols_fans,
              type: 'line',
              smooth: true,
              color: '#F23939'
            }
          ]
        }
        let linechart_kolfans = echarts.init(this.$refs.line_chart_kolfans);
        linechart_kolfans.setOption(lineoption_kolfans);
        // ===柱状图===
        let bardata = res.data.result[0].bar_data;
        // 达人粉丝分布图
        let baroption_fans = {
          tooltip: {
            show: true,
            trigger: 'axis'
          },
          xAxis: {
            type: 'category',
            data: bardata.kols_fans.x_names,
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: bardata.kols_fans.y_vales,
              type: 'bar',
              smooth: true,
              color: '#396AF2'
            }
          ]
        }
        let barchart_fans = echarts.init(this.$refs.bar_chart_fans);
        barchart_fans.setOption(baroption_fans);
        // 达人薯种分布图
        let baroption_level = {
          tooltip: {
            show: true,
            trigger: 'axis'
          },
          xAxis: {
            type: 'category',
            data: bardata.kols_level.x_names,
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: bardata.kols_level.y_vales,
              type: 'bar',
              smooth: true,
              color: '#396AF2'
            }
          ]
        }
        let barchart_level = echarts.init(this.$refs.bar_chart_level);
        barchart_level.setOption(baroption_level);
        // 达人类目分布图
        let baroption_category = {
          tooltip: {
            show: true,
            trigger: 'axis'
          },
          xAxis: {
            type: 'category',
            data: bardata.kols_category.x_names,
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: bardata.kols_category.y_vales,
              type: 'bar',
              barWidth: 50,
              smooth: true,
              color: '#F5a20A'
            }
          ]
        }
        let barchart_category = echarts.init(this.$refs.bar_chart_category);
        barchart_category.setOption(baroption_category);
        // ===饼状图===
        // 达人合作类型饼状图
        let piedata = res.data.result[0].pie_data;
        let peidata_cooperation = [];
        for(let i = 0; i　< piedata.note_cooperate.x_names.length; i++) {
          let ndic = { name: piedata.note_cooperate.x_names[i], value: piedata.note_cooperate.y_vales[0][i]};
          peidata_cooperation.push(ndic);
        }
        let pieoption_cooperation = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            top: '10%',
            left: 'center'
          },
          color: ['#396AF2', '#F5a20A', '#F52c9b', '#52C1D0', '#F23939'],
          series: [
            {
              name: piedata.note_cooperate.y_names[0],
              type: 'pie',
              top: '20%',
              radius: '50%',
              data: peidata_cooperation,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
        let piechart_cooperation = echarts.init(this.$refs.pie_chart_cooperation);
        piechart_cooperation.setOption(pieoption_cooperation);
        // 达人性别类型饼状图
        let peidata_gender = [];
        for(let i = 0; i　< piedata.note_gender.x_names.length; i++) {
          let ndic = { name: piedata.note_gender.x_names[i], value: piedata.note_gender.y_vales[0][i]};
          peidata_gender.push(ndic);
        }
        let pieoption_gender = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            top: '10%',
            left: 'center'
          },
          color: ['#396AF2', '#F5a20A', '#F52c9b', '#52C1D0', '#F23939'],
          series: [
            {
              name: piedata.note_gender.y_names[0],
              type: 'pie',
              top: '20%',
              radius: '50%',
              data: peidata_gender,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
        let piechart_gender = echarts.init(this.$refs.pie_chart_gender);
        piechart_gender.setOption(pieoption_gender);
        // // 达人地域分布图
        // let baroption_location = {
        //   tooltip: {
        //     show: true,
        //     trigger: 'axis'
        //   },
        //   xAxis: {
        //     type: 'category',
        //     data: bardata.kols_location.x_names,
        //   },
        //   yAxis: {
        //     type: 'value'
        //   },
        //   series: [
        //     {
        //       data: bardata.kols_location.y_vales,
        //       type: 'bar',
        //       barWidth: 50,
        //       smooth: true,
        //       color: '#52C1D0'
        //     }
        //   ]
        // }
        // let barchart_location = echarts.init(this.$refs.bar_chart_location);
        // barchart_location.setOption(baroption_location);

        let map_data = [];
        for(let i = 0; i　< bardata.kols_location.x_names.length; i++) {
          let ndic = { name: bardata.kols_location.x_names[i], value: bardata.kols_location.y_vales[i]};
          map_data.push(ndic);
        }

        // 达人地域分布地图
        let mapoption_location = {
          visualMap: {
            show: true,
            bottom: 20,
            left: 100,
            // left: 50, top: '30%', right: 0, bottom: 0,  //定位的左上角以及右下角分别所对应的经纬度
            text: ["200", "0"],
            min: 0,
            itemHeight: 200,  //图形的高度，即长条的高度。
            color: [
              '#ee6666',//红色
              '#fc8452',//橙色
              '#fac858',//黄色
              '#9a60b4',//紫色
              '#ea7ccc',//淡紫
              '#3ba272',//绿色
              '#91cc75',//浅绿
              '#5470c6',//蓝色
              '#73c0de',//淡蓝
            ]
          },
          geo: {  // 地理坐标系组件用于地图的绘制// geo配置详解： https://echarts.baidu.com/option.html#geo
            map: "china", // 表示中国地图
            // roam: true, // 是否开启鼠标缩放和平移漫游
            zoom: 1.2, // 当前视角的缩放比例（地图的放大比例）
            label: {
              show: true
            },
            emphasis: {  // 地图区域的多边形 图形样式。
              borderColor: "#ffffff",//未选中的状态
              areaColor: "#D8E9FD", //背景颜色
              label: {
                show: true, //显示名称
              },
              itemStyle: {  //选中的状态// 高亮状态下的多边形和标签样式
                shadowBlur: 20,
                shadowColor: "rgba(0, 0, 0, 0.5)",
                borderColor: "#fff",
                areaColor: "#DA3A3A",
              },
            },
          },
          series: [
            {
              name: "达人地域分布",
              type: "map",
              geoIndex: 0,
              label: {
                show: true,
              },
              data: map_data,
            }
          ]
        }
        echarts.registerMap("china", china);
        let mapchart_location = echarts.init(this.$refs.map_chart_location);
        mapchart_location.setOption(mapoption_location);
      }).catch((res) => {
        console.log("..fail: ", res);
      })
    }
  },
  mounted () {
    console.dir(this.$cookies);
    if (this.$cookies.get('UserToken')) {
      this.getListData();
    } else {
      console.dir('退出登录');
      this.clickLogout ();
    }
  },
  metaInfo: {
    title: "袤-AI数据挖掘系统",
    meta: [
      { name: "viewport", content: "width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0" },
      { name: "keywords", content: "袤周-大数据驱动下的智慧种草平台" },
      { name: "description", content: "袤周-大数据驱动下的智慧种草平台" },
      { name: "format-detection", content: "telephone=no,email=no" }
    ],
    link: [{
      rel: 'shortcut icon',
      href: '/static/favicon.ico'
    }]
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '../comm/css/base.styl'
.main_view
  height 100vh
  -webkit-overflow-scrolling touch
  background-color $brand-bgm
  display flex
  flex-direction column
  width 100%
  overflow-y scroll
  overflow-x hidden
  .report_head
    position absolute
    left 0
    top 0
    width 100%
    z-index 1
    background-color $white
    height 75px
    box-shadow 0 1px 8px 0 rgba(0,0,0,0.1)
    .report_head_item
      width 1000px
      height 75px
      display flex
      margin 0 auto
      flex-direction row
      align-items center
      justify-content space-between
      .report_head_right
        width auto
        display flex
        position relative
        height 75px
        flex-direction row
        align-items center
        .item_right
          width auto
          display flex
          position relative
          height 75px
          flex-direction row
          align-items center
          .img_head
            height 32px
            border-radius 50px
            width 32px
          .logout
            position absolute
            width 120px
            height 38px
            display flex;
            flex-direction column
            align-items center
            justify-content center
            color $white
            cursor pointer
            z-index 1
            right 0
            top 60px
            font-size 14px
            background $grey
          .nick_name
            color $color-two
            font-size 14px
            margin-left 10px
      .report_head_left
        width auto
        display flex
        flex-direction row
        align-items center
        height auto
        .note
          margin-left 15px
          color $color-two
          font-size 20px
          font-weight bold;
          width auto
          display flex
          position relative
          height 75px
          flex-direction row
          align-items center
        .line
          margin-left 10px
          width 1px
          height 57px
          background-color $colorE
        .report_info
          height auto
          display flex
          flex-direction column
          img
            height auto


  .report_home
    display flex
    flex-direction row
    justify-content center
    margin 0 auto
    margin-top 90px
    width 1000px
    .shop
      display flex
      flex-direction row
      width 100%
      .report_list
        display flex
        width 100%
        flex-direction column
        .report_item_head
          display flex
          margin-top 15px
          margin-bottom 15px
          width 100%
          align-items center
          justify-content center
          flex-direction row
          .report_item_value
            height 30px
            width auto
            line-height 30px
            margin-right 40px
            font-size 12px
            cursor pointer
            color $color-six
            &.selected
              border-bottom solid 3px $brand-blue
              font-weight bold
              color $brand-blue
              font-size 14px

  .report_item
    display flex
    flex-direction column
    margin 0 auto
    width 1000px
    height auto
    .head_item
      margin-top 10px
      height 30px
      display flex
      position relative
      align-items center
      color #111
      font-size 16px
    .report
      width 100%
      border-radius 12px
      height auto
      background-color $white
      display flex
      flex-direction row
      &.show_item
        padding-top 10px
        background-color $brand-bgm
        flex-wrap wrap
      .show_child_item
        display flex
        margin-bottom 5px
        width 240px
        border-radius 12px
        height 150px
        justify-content center
        align-content center
        align-items center
        flex-direction column
        background-color $white
        margin-right 10px
        .name
          color $brand-blue
          font-size 24px
        .note
          margin-top 5px
          font-size 12px
          font-weight inherit
          color $brand-gray

  .report_echarts_double
    display flex
    flex-direction row
    margin 0 auto
    height auto
    .report_echarts_one
      width 490px
      .echarts_head
        margin-top 10px
        margin-bottom 10px
        height 30px
        display flex
        position relative
        align-items center
        color #111
        font-size 16px
      .echarts_map
        border-radius 12px
        width 100%
        height 300px
        background-color $white
    .report_echarts_two
      width 490px
      margin-left 20px
      .echarts_head
        margin-top 10px
        margin-bottom 10px
        height 30px
        display flex
        position relative
        align-items center
        color #111
        font-size 16px
      .echarts_map
        border-radius 12px
        width 100%
        height 300px
        background-color $white

  .report_echarts
    display flex
    flex-direction column
    margin 0 auto
    width 1000px
    height auto
    .echarts_head
      margin-top 10px
      margin-bottom 10px
      height 30px
      display flex
      position relative
      align-items center
      color #111
      font-size 16px
    .echarts_map
      border-radius 12px
      width 100%
      height 300px
      background-color $white

  .report_echarts_map
    display flex
    flex-direction column
    margin 0 auto
    width 1000px
    height auto
    .echarts_head
      margin-top 10px
      margin-bottom 10px
      height 30px
      display flex
      position relative
      align-items center
      color #111
      font-size 16px
    .echarts_map_map
      border-radius 12px
      width 100%
      height 500px
      background-color $white

  .report_trend
    display flex
    flex-direction row
    margin 0 auto
    height auto
    .report_echarts_one
      width 490px
      .echarts_head
        margin-top 10px
        margin-bottom 10px
        height 30px
        display flex
        position relative
        align-items center
        color #111
        font-size 16px
      .echarts_map
        border-radius 12px
        width 100%
        height 300px
        background-color $white
    .report_echarts_two
      width 490px
      margin-left 20px
      .echarts_head
        margin-top 10px
        margin-bottom 10px
        height 30px
        display flex
        position relative
        align-items center
        color #111
        font-size 16px
      .echarts_map
        border-radius 12px
        width 100%
        height 300px
        background-color $white

.bottom_div
  background linear-gradient(135deg, rgba(51,51,51,1) 0%, rgba(17,17,17,1) 100%)
  width 100%
  height auto
  padding-top 20px
  padding-bottom 20px
  display flex
  color $white
  justify-content center
  flex-direction row
  align-items center
  a
    margin-left: 10px
    margin-top 20px
    margin-bottom 20px
    color $white
</style>



// WEBPACK FOOTER //
// src/components/bigdata/BigdataKol.vue